import React from "react";

export const ContactForm = () => {
  return (
    <div className="col-12 ">
      <iframe
        src="https://docs.google.com/forms/d/e/1FAIpQLScVXLLoYXslcxz4ivTi3oPoJOvYBmOqmZ8x_PcjiJmYOnwl1A/viewform?usp=sharing"
        width="100%"
        height="1000"
        frameBorder="0"
        marginHeight="0"
        marginWidth="0"
        allowFullScreen
        title="Google Form"
      >
        Loading ...
      </iframe>
    </div>
  );
};
